import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {VideoOverlayItemBox} from "../video-overlay-item/video-overlay-item.box";
import {VideoSoundButtonComponent} from "../video-sound-button/video-sound-button.component";
import {IVideoPlayingService} from "../../../../services/video-live-stream/video-playing.service.interface";

export interface VideoTileOverlayComponentProps {
    videoPlayingService: IVideoPlayingService;
    videoPlaying: boolean;
    bottomLeftComponent?: React.ReactNode;
    bottomRightComponent?: React.ReactNode;
}

export class VideoTileOverlayComponent extends OrbitComponent<VideoTileOverlayComponentProps> {

    private _padding = "1rem";

    private _renderTopRight(): React.ReactElement {
        if (!this.props.videoPlaying) {
            return null;
        }

        return (
            <VideoOverlayItemBox transparent style={{position: "absolute", top: this._padding, right: this._padding}}>
                <VideoSoundButtonComponent videoPlayingService={this.props.videoPlayingService}/>
            </VideoOverlayItemBox>
        );
    }

    private _renderBottomLeft(): React.ReactElement {
        if (!this.props.bottomLeftComponent) {
            return null;
        }

        return (
            <VideoOverlayItemBox capsule style={{position: "absolute", bottom: this._padding, left: this._padding}}>
                {this.props.bottomLeftComponent}
            </VideoOverlayItemBox>
        );
    }

    private _renderBottomRight(): React.ReactElement {
        if (!this.props.bottomRightComponent) {
            return null;
        }

        return (
            <VideoOverlayItemBox style={{position: "absolute", bottom: this._padding, right: this._padding}}>
                {this.props.bottomRightComponent}
            </VideoOverlayItemBox>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this._renderTopRight()}
                {this._renderBottomLeft()}
                {this._renderBottomRight()}
            </React.Fragment>
        );
    }
}
